import React, { useState, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { vehicleService } from "./vehicleService";
import { IVehicleSearch, IVehicleDetail, IVehicleFields } from "./vehicleType"
import { globalPrompt } from "@/components/message";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination, getOptionsOne } from "@/utils/utils";
import { useCustomerModel } from "../customer/baseCustomerModel"
import { useDictModel } from "../../dict/dictModel";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums"
import { useGlobalModel } from "@/model/globalModel";
import moment from "moment"
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useLockFn } from "ahooks";
// vehicleData, 
// setvehicleData, 
// clearvehicleData
export const useVehicleModel = createModel(function () {
    const { getTreeNodeName } = useDictModel();
    const { user, CustomerData, setVehicleData, setLocale } = useGlobalModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //列表数据
    const [dataSource, setDataSource] = useState<IVehicleDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IVehicleFields>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<IVehicleFields>({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<IVehicleFields>({});


    //设置搜索value
    const updateSearchParam = (updateParam: IVehicleFields) => {
        console.log(updateParam)
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //所有列表查询
    const loadVehicleAllData = async () => {
        const params = {
            pageSize: 1000,
            pageNum: 1
        }
        let { retData } = await vehicleService.page(params);
        const { records, ...pg } = retData;

        setVehicleData(records)
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IVehicleFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await vehicleService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        loadVehicleAllData()
    }
    //表单新增修改
    const updateAddFormVal = (val: IVehicleFields | null) => {

        let newVal = val
        if (newVal && "customerCode" in newVal) {
            let { contact, phone, name, address } = getOptionsOne(newVal.customerCode as string, CustomerData)
            console.log(getOptionsOne(newVal.customerCode as string, CustomerData))
            newVal = { ...val, contact, phone, address, customerName: name }
        }
        if (newVal && "categoryCode" in newVal) {
            newVal = { ...val, categoryName: getTreeNodeName(newVal.categoryCode as string) }
        }
        val ? setAddFormVal({ ...addFormVal, ...newVal }) : setAddFormVal({});
    }
    //表单新增修改
    const updateEditFormVal = (val: IVehicleFields | null) => {
        let newVal = val
        if (newVal && "customerCode" in newVal) {
            let { contact, phone, name, address } = getOptionsOne(newVal.customerCode as string, CustomerData)
            newVal = { ...val, contact, phone, address, customerName: name }
        }
        if (newVal && "categoryCode" in newVal) {
            newVal = { ...val, categoryName: getTreeNodeName(newVal.categoryCode as string) }
        }
        val ? setEditFormVal({ ...editFormVal, ...newVal }) : setEditFormVal({});
    }
    //获取一条详情数据 Api
    const getDetailOne = async (id: string) => {
        let { retData } = await vehicleService.one(id);
        retData && setEditFormVal({ ...retData, registerDate: retData.registerDate ? moment(retData.registerDate) : null });
    }
    //表单新增 Api
    const insertDetail = useLockFn(async (data: IVehicleDetail) => {
        let params = {
            ...addFormVal,
            // ...sourceAppOrBranch,
            sourceApp: mianCode,
            branch: mianCode,
            enable: addFormVal.enable ? 1 : 0,
            createUser: user.username,
            registerDate: addFormVal.registerDate ? moment(addFormVal.registerDate).format("YYYY-MM-DD HH:mm:ss") : null
        }
        let { retData } = await vehicleService.insert(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "车辆新增成功", type: "success" })
            // : globalPrompt("message", { text: "车辆新增失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully added"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully added"], type: "error" });
        return retData;
    })

    //表单编辑 Api
    const editDetail = useLockFn(async (data: IVehicleDetail) => {
        let params = {
            ...editFormVal,
            // ...sourceAppOrBranch,
            sourceApp: mianCode,
            branch: mianCode,
            enable: editFormVal.enable ? 1 : 0,
            updateUser: user.username,
            registerDate: editFormVal.registerDate ? moment(editFormVal.registerDate).format("YYYY-MM-DD HH:mm:ss") : null
        }
        let { retData } = await vehicleService.update(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "车辆编辑成功", type: "success" })
            // : globalPrompt("message", { text: "车辆编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    })
    //车辆状态开启禁用
    const onDisabled = async (id: string, checked: boolean) => {
        let { retData } = await vehicleService.disable({ id, enable: checked ? 1 : 0 })
        retData ?
            // loadData() && globalPrompt("message", { text: "供应商编辑成功", type: "success" })
            // : globalPrompt("message", { text: "供应商编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    //导入
    const importData = async (file: { file: File }) => {
        let { retData } = await vehicleService.import(file);
        retData ?
            // loadData() && globalPrompt("message", { text: "导入成功", type: "success" })
            // : globalPrompt("message", { text: "导入失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully imported"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully imported"], type: "error" });
        return retData;
    }

    //导出
    const exportData = async (searchValue: IVehicleSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let result = await vehicleService.export(searchParams);
        convertRes2Blob(result);
    }
    //下载模板
    const downloadTpl = async () => {
        let result = await vehicleService.downloadTpl();
        convertRes2Blob(result);
        // let { retData } = await vehicleService.downloadTpl();
        // retData ?
        //     globalPrompt("message", { text: "下载模板成功", type: "success" })
        //     : globalPrompt("message", { text: "下载模板失败", type: "error" });
        // return retData;
    }
    return {
        initPgCfg,
        dataSource,
        searchParam,
        pgCfg,
        selectedRowKeys,
        addFormVal,
        editFormVal,
        setAddFormVal,
        setSelectedRowKeys,
        setPgCfg,
        setSearchParam,
        setDataSource,
        updateSearchParam,
        resetSearchParam,
        loadData,
        updateAddFormVal,
        updateEditFormVal,
        getDetailOne,
        insertDetail,
        editDetail,
        importData,
        exportData,
        downloadTpl,
        loadVehicleAllData,
        onDisabled
    }
})